import config from './config';

const breadcrumbs = config({
  /** Defaults for all sites and locales. */
  default: {
    default: {
      /**
       * When true, the last breadcrumb is rendered as plain text (current page).
       * When false, the last breadcrumb is rendered as a link like the others.
       */
      showLastCrumbAsText: false
    }
  },
  /** HOKA-US: last breadcrumb rendered as plain text per Figma Pre-Checkout Reference. */
  'HOKA-US': { default: { showLastCrumbAsText: true } }
});

export default breadcrumbs;
